<h2>Categories</h2>

<div>
  <label for="new-category">New Category: </label>
  <input class="name-field" id="new-category" #categoryName />

  <button
    mat-fab
    (click)="addCategory(categoryName.value); categoryName.value = ''"
    color="primary"
    aria-label="Add category"
  >
    <mat-icon>add</mat-icon>
  </button>
</div>

<div cdkDropList class="category-list" (cdkDropListDropped)="drop($event)">
  @for (category of categories; track category._id) {
    <div class="category-item" cdkDrag (click)="onSelect(category)">
      <a>
        <span class="badge"> {{ category.order }} </span>
        {{ category.name }}
      </a>
      <button (click)="deleteCategory(category)" class="delete" aria-label="Delete category">
        x
      </button>
    </div>
  }
</div>
